import type { ProductListData, CartParams, CartComponentInstance } from "@common/types/commonTypes/functions";
import { createApp, defineComponent, onMounted, ref } from "vue";
export const cartInstance = async (params: CartParams): Promise<CartComponentInstance | undefined> => {
  const appEl = $(params.pageMarker).find("#app");
  if (!$(appEl).length) return;
  // const App = defineComponent({
  //   data(): ProductListData {
  //     return {
  //       pageMarker: params.pageMarker,
  //       productList: [],
  //       idList: [],
  //       storeKey: params.storeKey || "cartList",
  //       storeType: (params.storeKey || "section") as storeType,
  //     };
  //   },
  //   async created() {
  //     this.idList = JSON.parse(window.localStorage.getItem(this.storeKey) || "[]");
  //     await this.getData();
  //   },
  //   methods: {
  //     async getData() {
  //       try {
  //         const res = await $.ajax({
  //           contentType: "application/json",
  //           url: "/get_products",
  //           method: "GET",
  //           data: { product_id: this.idList.join(",") },
  //         });
  //         this.productList = res.data;
  //       } catch (error) {
  //         console.log(error);
  //       }
  //     },
  //     isInCart(id: string | number) {
  //       id = typeof id === "string" ? Number(id) : id;
  //       return this.idList.filter((i) => i === id)[0];
  //     },
  //     handleCart(ids?: Array<string | number>) {
  //       ids = Array.isArray(ids) ? ids : this.idList;
  //       ids.map((id) => {
  //         id = Number(id);
  //         const item = this.isInCart(id);
  //         if (item) {
  //           // 存在，移除
  //           this.idList = this.idList.filter((i) => i !== id);
  //           this.productList = this.productList.filter((product) => product.id !== id);
  //         } else {
  //           // 不存在，新增
  //           this.idList.push(id);
  //         }
  //       });
  //       window.localStorage.setItem("cartList", JSON.stringify(this.idList));
  //     },
  //   },
  // });
  const storeKey = params.storeKey || "cartList";
  let readyResolve!: () => void;
  const readyPromise = new Promise<void>((resolve) => {
    readyResolve = resolve;
  });
  const App = defineComponent({
    setup() {
      const productList = ref<ProductListData[]>([]);
      const idList = ref<number[]>([]);
      // 封装获取数据函数
      const getData = async () => {
        try {
          const res = await $.ajax({
            contentType: "application/json",
            url: "/get_products",
            method: "GET",
            data: { product_id: idList.value.join(",") },
          });
          productList.value = res.data;
        } catch (error) {
          console.error(error);
        }
      };

      // 判断商品是否在购物车内
      const isInCart = (id: string | number): number | undefined => {
        const numId = typeof id === "string" ? Number(id) : id;
        return idList.value.find((i) => i === numId);
      };

      // 处理购物车逻辑：新增或移除
      const handleCart = (ids?: Array<string | number>) => {
        const providedIDs = Array.isArray(ids) ? ids : idList.value;
        providedIDs.forEach((idInput) => {
          const id = Number(idInput);
          if (isInCart(id)) {
            // 移除已存在的
            idList.value = idList.value.filter((i) => i !== id);
            productList.value = productList.value.filter((product) => product.id !== id);
          } else {
            // 新增
            idList.value.push(id);
          }
        });
        window.localStorage.setItem(storeKey, JSON.stringify(idList.value));
      };

      onMounted(async () => {
        // 1. 读 localStorage
        idList.value = JSON.parse(window.localStorage.getItem(storeKey) || "[]");
        // 2. 拉数据
        await getData();
        // 3. 通知外部：初始化完成
        readyResolve();
      });

      // 返回需要暴露给外部的属性和方法
      return {
        productList,
        idList,
        isInCart,
        handleCart,
      };
    },
  });
  const app = createApp(App);
  const Instance = app.mount(appEl[0]) as unknown as CartComponentInstance;
  await readyPromise;
  return Instance;
};
